import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section, StatusBadge, fmtTime } from "@/components/Shared";
import { toast } from "sonner";

export default function AdminMyAttendance() {
  const [recs, setRecs] = useState([]);
  useEffect(() => {
    api.get("/attendance/me").then((r) => setRecs(r.data)).catch((e) => toast.error(formatErr(e)));
  }, []);
  return (
    <div data-testid="admin-my-attendance">
      <PageHeader overline="History" title="My Attendance" subtitle="Your personal daily clock-in/out log." />
      <Section title="Recent records">
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Date</th><th className="eyebrow">In</th><th className="eyebrow">Out</th>
              <th className="eyebrow">Break</th><th className="eyebrow">Hours</th><th className="eyebrow">Status</th>
            </tr>
          </thead>
          <tbody>
            {recs.length === 0 && <tr><td colSpan={6} className="text-center py-8 text-neutral-500">No records yet</td></tr>}
            {recs.map((r) => (
              <tr key={r.id} className="border-b border-[#F0F0EE]">
                <td>{r.date}</td>
                <td>{fmtTime(r.clock_in)}</td>
                <td>{fmtTime(r.clock_out)}</td>
                <td>{r.break_minutes || 0}m</td>
                <td className="font-semibold">{r.working_hours || 0}h</td>
                <td><StatusBadge status={r.status || "Present"} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
    </div>
  );
}
